module.exports = __webpack_public_path__ + "static/seoImage-dc2e68899d9875df4684bc4840a9c2d0.png";